import type { MaterialFormula } from "./types.js";
import { ceilSafe, resolveInput, round2 } from "./util.js";

/** ฝ้ายิปซัมฉาบเรียบ แผ่น 1.2x2.4 ม. */
export const ceilGyps: MaterialFormula = (input) => {
  const { area, waste } = resolveInput(input);
  return [
    { key: "gypsum_board", name_th: "ยิปซัมบอร์ด 1.2x2.4 ม.", qty: ceilSafe((area / 2.88) * (1 + waste)), unit: "แผ่น", qty_basis: "area/2.88 x (1+waste)" },
    { key: "furring_channel", name_th: "โครงคร่าว", qty: round2(2.5 * area), unit: "ม.", qty_basis: "2.5 ม./ตร.ม." },
    { key: "main_channel", name_th: "โครงหลัก", qty: round2(1.5 * area), unit: "ม.", qty_basis: "1.5 ม./ตร.ม." },
    { key: "hanger", name_th: "Hanger Rod + Clips", qty: ceilSafe(area / 1.44), unit: "ชุด", qty_basis: "area/1.44" },
    { key: "skim_coat", name_th: "สกิมโค้ท", qty: round2(0.5 * area), unit: "กก.", qty_basis: "0.5 กก./ตร.ม." },
    { key: "screw", name_th: "สกรูยิปซัม", qty: ceilSafe(15 * area), unit: "ตัว", qty_basis: "15 ตัว/ตร.ม." },
  ];
};
